var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasContent
    ? _c(
        "NsProductCardBase",
        {
          attrs: {
            "adr-price": _vm.adrPrice,
            "adr-price-type": _vm.adrPriceType,
            "disable-add-to-adr": _vm.disableAddToAdr,
            "disable-add-to-cart": _vm.disableAddToCart,
            "disable-quantity-selector": _vm.disableQuantitySelector,
            "exclusive-offer-message": _vm.exclusiveOfferMessage,
            forcesv: _vm.forcesv,
            "hide-exclusive-icon": _vm.hideExclusiveIcon,
            "hide-exclusive-text-on-mobile": _vm.hideExclusiveTextOnMobile,
            "hide-favorites": _vm.hideFavorites,
            "hide-sku": _vm.hideSku,
            "image-fallback-src": _vm.imageFallbackSrc,
            image: _vm.image,
            "image-set": _vm.imageSet,
            "is-base-sku": _vm.isBaseSku,
            "is-distributor": _vm.isDistributor,
            "is-exclusive": _vm.isExclusive,
            "is-favorite": _vm.isFavorite,
            "is-logged-in": _vm.isLoggedIn,
            "is-loyalty-enabled": _vm.isLoyaltyEnabled,
            "is-sale": _vm.isSale,
            "loyalty-status-and-links": _vm.loyaltyStatusAndLinks,
            "market-attributes": _vm.marketAttributes,
            "max-quantity": _vm.maxQuantity,
            "min-price": _vm.minPrice,
            "max-price": _vm.maxPrice,
            "mobile-side-by-side": _vm.mobileSideBySide,
            "no-action": _vm.noAction,
            "show-action": _vm.showAction,
            "original-price": _vm.originalPrice,
            "original-price-label": _vm.originalPriceLabel,
            "original-price-type": _vm.originalPriceType,
            points: _vm.points,
            price: _vm.price,
            "price-label": _vm.priceLabel,
            "price-type": _vm.priceType,
            quantity: _vm.quantity,
            "sales-label": _vm.salesLabel,
            "show-adr-only": _vm.showAdrOnly,
            "show-exclusive-offer-message": _vm.showExclusiveOfferMessage,
            "show-original-crossed-out": _vm.showOriginalCrossedOut,
            "show-price-labels": _vm.showPriceLabels || _vm.showAdrOnly,
            "show-variant-selector": _vm.showVariantSelector,
            sku: _vm.activeSku,
            "status-message": _vm.statusMessage,
            "status-message-key": _vm.statusMessageKey,
            title: _vm.title,
            translations: _vm.localTranslations,
            "user-is-qualified": _vm.userIsQualified,
            "user-loyalty": _vm.userLoyalty,
            variants: _vm.variants,
            "variant-skus": _vm.variantSkus
          },
          on: {
            "variant-select": _vm.handleVariantSelect,
            "quantity-select": _vm.handleQuantitySelect,
            "add-to-cart": _vm.handleAddToCart,
            "add-to-adr": _vm.handleAddToAdr,
            "card-click": _vm.handleCardClick,
            "favorite-click": _vm.handleFavoriteClick
          }
        },
        [_vm._t("default")],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }